
// 插件路由
const topic = () => import(/* webpackChunkName: "topic" */ '~/addon/topic/pages/topic.vue')

const routes = [
	{ 
        path: '/topic', 
        component: topic 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/topic/router/index.js